import request from 'services/axios';

export const saledPost = async (payload: ISaledPost) => {
  const response = await request.patch(`/api/v2/market/post`, {
    guid: payload.guid,
  });
  return response;
};
